import React, { Component } from 'react'
import tools from '@/utils/tool';
import API from '@/config/api';
import httpRequest from '@/utils/httpRequest'
import {Toast} from 'antd-mobile';
import './index1.scss'

export default class index extends Component {
  constructor(props){
    super(props)
    this.state = {
      data:{},
      url:'',
    }
  }

  componentDidMount(){
    let url = window.location.href
    let parameter =  tools.getParams(url)
    this.setState({
      url:parameter.url,
    },() => {
      this.getList(parameter.url)
    })    
  }

  getList = (url) => {
     Toast.loading('Loading...', 1);
    httpRequest({
      url: API.organization_detail,
      type: 'post',
      data: {
        proxy_url:url
      }
    }).done((resp) => {
      Toast.hide()
      if (resp.code === 0) {
        // 兼容返回的富文本样式，替换表格标签
        let a = resp.data.content.replace(/table/g,'p')
        let b = a.replace(/tbody/g,'p')
        let c = b.replace(/tr/g,'p')
        let d = c.replace(/td/g,'p')
        let e = d.replace(/style=\"(.*?)\"/g,'')
        let f = e.replace(/size=\"(.*?)\"/g,'')
        resp.data.content = f
        this.setState({
          data:resp.data,
          type:resp.type
        })
      } else {
        Toast.fail(resp.msg || resp.error);
      }
    }).fail(jqXHR => {
      Toast.hide()
      Toast.fail(jqXHR.msg || jqXHR.error);
    })
  }

  render() {
    const {data} = this.state
    return (
      <div className='detailWrapper'>
        {data.type / 1 === 1 ? // 富文本
          <div className="content1">
            <div dangerouslySetInnerHTML = {{
              __html:data.content
            }}/>
          </div>
        :  // 普通标签文本
          <div className="content2">
            <div className="title">{data.title}</div>
            <div className="content">
              <div dangerouslySetInnerHTML = {{
                __html:data.content
              }}/>
            </div>
            
          </div>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Organization/Organization_detail/index.js